import type { IAppFeatures } from '__generated__';
import { useGetAppFeaturesQuery } from './api';

/**
 * R-39 / ADR-057 — the single gate for the unfinished committee-matrix features in the rating
 * process (ballot, report-matrix export, R-38 badges). Temporary: at go-live, search for
 * `isMatrixEnabled` and remove every call. Not for the template-management module.
 * F-23 — the matrix picker and chips in the committee step are gated too.
 */
export const isMatrixEnabled = (features: IAppFeatures | null | undefined) =>
  features?.includeMatrix === true;

/** False while the flags load, so nothing gated flashes in on production. */
export const useIsMatrixEnabled = () => {
  const { data } = useGetAppFeaturesQuery();
  return isMatrixEnabled(data);
};
